// test2521
(2521 && 0);
